import { Component, OnInit } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ReturnedTerminalsViewModel } from '../../models/returned-terminals-view-model';
import { AuthenticationService } from '../../services/authentication.service';
import { PermissionEnum } from '../../services/guards/permissions';
import { ReportService } from '../../services/report.service';
import { UserDataStoreService } from '../../services/user-data-store.service';
import { ParticipantViewModel } from '../../models/participant-view-model';
import { Select2OptionData } from 'ng-select2';
import { promise } from 'protractor';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-returned-terminals',
  templateUrl: './returned-terminals.component.html',
  styleUrls: ['./returned-terminals.component.scss']
})
export class ReturnedTerminalsComponent implements OnInit {

  public raiseWarning: boolean;
  public raiseDanger: boolean;
  public hasData: boolean;
  public warning: string;
  public danger: string;
  public startDate: Date;
  public endDate: Date;
  public all: boolean;

  public customers: Select2OptionData[] = [];
  //  public customers: string[] = [];
  public canView: boolean;
  public noData: string;
  public raiseNoData: boolean;
  public reportData: ReturnedTerminalsViewModel[] = [];
  public selectedCustomer: string
  public terminalNumber: string;
  public serialNumber: string;
  public serialNumberfc: FormControl;
  public terminalNumberfc: FormControl;
  public allfc: FormControl;
  public SerialNrOption: boolean;
  public TerminalIdOption: boolean;
  public selectedOption: string;
  public select2options: any = {
    multiple: false,
    width: '100%'
  };
  constructor(private _changeDetectorRef: ChangeDetectorRef,
    private _toastService: ToastrService,
    private _modalService: NgbModal,
    private _authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private _userDataStore: UserDataStoreService,
    private _router: Router,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private _reportService: ReportService,
    private _ngxLoader: NgxUiLoaderService) {

    this.canView = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewReturnedTerminalsReport]);
    if (!this.canView) {
      this._toastService.warning("You do not have the required permissions to view this page, Please contact your system administrator", "Warning");
      this._router.navigate(['/']);

    }

    this.SerialNrOption = false;
    this.TerminalIdOption = false;
    this.selectedCustomer = "";
    this.hasData = false;

  }



  async ngOnInit() {
    /*this.customers = (await this._reportService.GetReturnedTerminalCustomers()).map((x) => {
      return { id: x.toString(), text: x.toString() }
    });*/
    this.serialNumberfc = new FormControl('');
    this.terminalNumberfc = new FormControl('');
    this.allfc = new FormControl(false);
  }

  onCustomerChange(customer: string) {
    this.selectedCustomer = customer;
  }

  updateCheckbox(value: boolean) {
    this.all = value;
  }

  public async submit(): Promise<void> {
    debugger;
    this._ngxUiLoaderService.start();

    var inValid = false;
    var isRequired = false;
    const terminalValue = this.terminalNumberfc.value?.trim();
    const serialValue = this.serialNumberfc.value?.trim();

    if (this.selectedOption == "SerialNr" && !serialValue) {
      this.raiseDanger = true;
      this.danger = "Serial number is required!";
      this.raiseWarning = false;
      this.raiseNoData = false;
      this._ngxUiLoaderService.stop();
      return;
    }

    if (this.selectedOption == "TerminalId" && !terminalValue) {
      this.raiseDanger = true;
      this.danger = "Terminal Id is required!";
      this.raiseWarning = false;
      this.raiseNoData = false;
      this._ngxUiLoaderService.stop();
      return;
    }

    if (this.terminalNumberfc.value) {
      await this.searchByTerminal(this.terminalNumberfc.value);
    }
    if (this.serialNumberfc.value) {
      await this.searchBySerial(this.serialNumberfc.value);
    }
    this._ngxUiLoaderService.stop();
  }

  public async searchByTerminal(terminalNr: string): Promise<ReturnedTerminalsViewModel[]> {
    this.renderWarning('terminalNr');

    const reportData = await this._reportService.GetReturnedTerminalsReport(`report/GetReturnedDevicesReportByTerminalNr/${terminalNr}`);
    this.renderResults(reportData);
    return;
  }

  public async searchBySerial(serialNr: string): Promise<ReturnedTerminalsViewModel[]> {
    this.renderWarning('serialNr');

    const reportData = await this._reportService.GetReturnedTerminalsReport(`report/GetReturnedDevicesReportBySerialNr/${serialNr}`);
    this.renderResults(reportData);
    return;
  }

  public async searchByAll(): Promise<ReturnedTerminalsViewModel[]> {
    this.renderWarning('all');

    const reportData = await this._reportService.GetReturnedTerminalsReport(`report/GetReturnedDevicesReportByAll`);
    this.renderResults(reportData);
    return;
  }

  public renderWarning(type: string): void {
    this.raiseDanger = false;
    var objectType = '';
    if (type.includes('terminal')) {
      objectType = "Terminal Id";
    } else if (type.includes('serial')) {
      objectType = "Serial Number";
    } else {
      objectType = "All terminal";
    }
    this.warning = "Search by " + objectType;
    this.raiseWarning = true;
  }

  public async renderResults(reportData: ReturnedTerminalsViewModel[]) {
    debugger;
    if (reportData == null || reportData == undefined || reportData?.length == 0) {
      this.noData = "No data available.";
      this.raiseNoData = true;
      this.hasData = false;
      this.raiseDanger = false;

    }
    else {
      this.reportData = reportData;
      this.raiseDanger = false;
      this.hasData = true;
      this.raiseNoData = false;
      this.noData = "";


    }
    return;
    this._ngxUiLoaderService.stop();
  }

  public async exportToCSV(): Promise<void> {

    const data = this.reportData;
    const replacer = (key, value) => (value === null ? '' : value); // specify how you want to handle null values here

    const headerRow = {
      Job: '',
      Serial: '',
      Customer: '',
      CustomerName: '',
      StockCode: '',
      CurrentStatus: '',
      Scanner: '',
      ReceivedOperator: '',
      ReceivedTime: '',
      DispatchNote: '',
      StatusID: '',
    }

    const header = Object.keys(headerRow);

    const data1 = data.map(element => ({

      Job: element.job,
      Serial: element.serial,
      Customer: element.customer,
      CustomerName: element.customerName,
      StockCode: element.stockCode,
      CurrentStatus: element.currentStatus,
      Scanner: element.scanner,
      ReceivedOperator: element.receivedOperator,
      ReceivedTime: element.receivedTime,
      DispatchNote: element.dispatchNote,
      StatusID: element.statusID,

    }))

    const csv = data1.map((row) =>
      header
        .map((fieldName) => JSON.stringify(row[fieldName], replacer))
        .join(',')
    );


    csv.unshift(header.join(','));
    const csvArray = csv.join('\r\n');

    const a = document.createElement('a');
    const blob = new Blob([csvArray], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    var fileName = 'Device_Request_Report_' + this.startDate + '_' + this.endDate + '_.csv';
    a.href = url;
    a.download = (fileName);
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  public async reset(): Promise<void> {
    this._ngxUiLoaderService.start();

    this.ClearTable();
    this.hasData = false;

    this._ngxUiLoaderService.stop();

  }

  public async ClearTable(): Promise<void> {

    this.reportData = [];
    const bankTransDiv = document.querySelector("div.bankTransactions"); // Find the bankTransaction div in our HTML

    while (bankTransDiv.firstChild) {
      bankTransDiv.removeChild(bankTransDiv.firstChild); //Remove all children from table div (if any)
    }
  }

  public onRadioChange(selectedOption: string): void {
    if (selectedOption == "SerialNr") {
      this.selectedOption = "SerialNr";
      this.SerialNrOption = true;
      this.TerminalIdOption = false;
      this.terminalNumberfc.setValue('');
    }
    else {
      this.selectedOption = "TerminalId";
      this.SerialNrOption = false;
      this.TerminalIdOption = true;
      this.serialNumberfc.setValue('');
    }
  }
}


